import React from "react";
import { Dropdown, DropdownButton, Spinner } from "react-bootstrap";

const DropDownButton = (props: any) => {
  const textButton = props.textButton ?? "";
  const handleClick = props.handleClick ?? "";
  const className = props.className ?? "";
  const dropdownItems = props.dropdownItems ?? [];
  const loading = props.loading ? props.loading : false;
  const icon = props.icon ? props.icon : "";

  return (
    <DropdownButton
      className={`${className}`}
      title={
        <>
          {icon && <span className="material-symbols-outlined">{icon}</span>}
          {textButton}
          {loading && (
            <Spinner
              animation="border"
              size="sm"
              className="ms-2" 
            />
          )}
        </>
      }
      disabled={loading}
    >
      {dropdownItems.map((dropdownItem: any, index: number) => (
        <Dropdown.Item key={index} className='ps-2'>
          <div onClick={()=>handleClick(dropdownItem?.key)}>{dropdownItem?.label}</div>
        </Dropdown.Item>
      ))}
    </DropdownButton>
  );
};

export default DropDownButton;
